import Flickity from 'flickity';
import 'flickity-imagesloaded';
import { isMobile, isTablet } from 'mobile-device-detect';

const Carousel = {
  elem: document.querySelectorAll('[data-carousel]'),
  defaults: {
    cellAlign: 'center',
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    imagesLoaded: false,
    arrowShape: 'M74.3312 19.3344L65 10 25 50 65 90 74.3312 80.6656 43.6656 50z'
  },

  init() {
    this.render();
  },

  flktyInstance(elem, options = {}) {
    options.draggable = isMobile || isTablet;
    const flkty = new Flickity(elem, Object.assign({}, this.defaults, options));
    // select initial slide
    flkty.select(0);
  },

  render() {
    if (!this.elem.length) return;

    // create flickity instance with options if available
    for (let i = 0; i < this.elem.length; i += 1) {
      const options = JSON.parse(this.elem[i].getAttribute('data-carousel'));

      if (options && options !== '') {
        Carousel.flktyInstance(this.elem[i], options);
      } else {
        Carousel.flktyInstance(this.elem[i]);
      }
    }
  }
};

export default Carousel;
